<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-card class="green lighten-5 pa-1">
            <Title title="設定" />
            <v-card-text class="pa-0">
                <v-tabs
                    v-model="currentTabIndex">
                    <v-tab v-for="item in settingItems" :key="item.tab">
                        <v-chip v-if="currentTabIndex == item.index" color="green lighten-4" label>
                            <v-icon>{{item.icon}}</v-icon>
                            {{item.tab}}                    
                        </v-chip>
                        <span v-else>
                            <v-icon>{{item.icon}}</v-icon>
                            {{item.tab}}
                        </span>
                    </v-tab>
                    <v-tab v-if="isSystemManager">
                        <v-icon>mdi-monitor</v-icon>システム管理
                    </v-tab>
                    <!-- 
                        User に v-if を付けているのは、システム管理者のライセンス管理画面において画像のインポートが出来ない現象を回避する為
                        (Userコンポーネント側にインポートした画像が行ってしまう…インスタンスが共有されている？ であれば、回避策は？ 同様の現象が今後も発生する可能性が大きい？)
                     -->
                    <v-tab-item><User v-if="currentTabIndex==0" /></v-tab-item>
                    <v-tab-item><Variety /></v-tab-item>
                    <v-tab-item><License /></v-tab-item>
                    <v-tab-item v-if="isSystemManager"><SystemManage /></v-tab-item>                
                </v-tabs>
            </v-card-text>
        </v-card>
    </v-container>
<!-- 
    <v-card width="100%" height="100%" class="ma-2">
        <v-container fluid>
            <v-app-bar dense color="primary" dark elevation="0">
                <v-icon dark>mdi-cog-outline</v-icon>
                <v-toolbar-title>設定</v-toolbar-title>
            </v-app-bar>
            <v-tabs
                v-model="currentTabIndex">
                <v-tab v-for="item in settingItems" :key="item.tab">
                    <v-chip v-if="currentTabIndex == item.index" color="green lighten-4">
                        <v-icon>{{item.icon}}</v-icon>
                        {{item.tab}}                    
                    </v-chip>
                    <span v-else>
                        <v-icon>{{item.icon}}</v-icon>
                        {{item.tab}}
                    </span>
                </v-tab>
                <v-tab v-if="isSystemManager">
                    システム管理
                </v-tab>
                <v-tab-item><User /></v-tab-item>
                <v-tab-item><Variety /></v-tab-item>
                <v-tab-item v-if="isSystemManager"><SystemManage /></v-tab-item>                
            </v-tabs>
        </v-container>
    </v-card>
 -->
</template>

<script>
    import Variety from '@/components/setting/items/Variety';
    import User from '@/components/setting/items/User';
    import License from '@/components/setting/items/License';
    import SystemManage from '@/components/setting/items/SystemManage';
    import Title from '@/components/seedling/items/TitleBar'
    export default {
        name: "Setting",
        components: {
            Variety,
            User,
            License,
            SystemManage,
            Title
        },
        computed: {
            isSystemManager: function () {                
                if (this.$store.getters["userData"] == null) {
                    return false
                }
                return this.$store.getters["userData"].isSystemManager
            }
        },
        data: function () {
            return {
                currentTabIndex: null,
                settingItems: [
                    {tab:"ユーザー情報", index:0, icon:"mdi-account"},
                    {tab:"作付作物", index:1, icon:"mdi-fruit-cherries"},
                    {tab:"ライセンス管理", index:2, icon:"mdi-license"},
                ]
            }
        },
    }
</script>
